import styled from 'styled-components'
import { Row, Col } from 'react-bootstrap'
import { theme } from './../../common'

export const CardWrapper = styled.div`
    background-color: ${theme.lightGrey};
    height: 100%;
    display: flex;
    flex-direction: column;
`
export const StyledHeader = styled.div`
    min-height: 125px;
    justify-content: space-between;
    display: flex;
    flex-direction: column;
`
export const StyledContent = styled.div`
    margin-top: 20px;
    max-height: 200px;
    overflow-y: auto;
    padding: 0 5px;
`
export const StyledCardContent = styled.div`
    padding: 10% 5%;
    flex-grow: 1;
`
export const StyledTitle = styled.h2`
    font-size: 2em;
    font-weight: bold;
`

export const StyledDate = styled.p`
    margin: 0px;
    font-size: 1em;
    font-weight: lighter;
    padding-bottom: 3%;
    border-bottom: 3px solid ${theme.primary};
`

export const FooterWrapper = styled.div`
   background-color: ${theme.grey};
   display: flex;
   flex-direction: row;
   flex-grow: 0;
   justify-content: space-between;
   padding: 3% 5%;
`

export const StyledKeepReading = styled.div`
    display: flex;
    flex-direction: row;
   align-items: center;
    p {
        margin: 0px;
        font-weight: bold;
        color: ${theme.white};
        font-size: 1.2em;
        margin-right: 10px;
    }
    img {
        width: 20px;
        height: 20px;
    }
`

export const SocialList = styled.ul`
    margin: 0px;
    padding: 0px;
    list-style-type: none;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`
export const SocialListItem = styled.li`
    margin: 0px;
    padding: 0px;
    margin: 0 3px;
    img {
        width: 20px;
        height: 20px;
    }
`

export const StyledImage = styled.img`
    width: 100%;
    height: auto;
`